"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CallHistoryItem;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _components = require("@sart/components");
var _content = require("@sart/content");
var _styles = require("@sart/styles");
var _excluded = ["item", "onPress", "lineColor", "missedCall"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function CallHistoryItem(props) {
  var item = props.item,
    onPress = props.onPress,
    lineColor = props.lineColor,
    missedCall = props.missedCall,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var content = (0, _content.useContent)();
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, (0, _extends2["default"])({
    style: styles.container,
    onPress: onPress
  }, rest), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.row
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: missedCall ? styles.numberMissed : styles.number
  }, "07484879264"), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.date
  }, "06/02/23")), /*#__PURE__*/_react["default"].createElement(_reactNative.View, {
    style: styles.row
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.tofrom
  }, "Incoming"), /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: styles.time
  }, "04:23PM")), /*#__PURE__*/_react["default"].createElement(_components.Space, {
    height: 8
  }), /*#__PURE__*/_react["default"].createElement(_components.HorizontalLine, {
    color: lineColor
  }));
}
var styles = _reactNative.StyleSheet.create({
  container: {
    width: '100%'
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  number: _objectSpread(_objectSpread({}, _styles.typography.demi), {}, {
    fontSize: 20,
    color: _styles.colors.srDarkGreen
  }),
  numberMissed: _objectSpread(_objectSpread({}, _styles.typography.demi), {}, {
    fontSize: 20,
    color: '#FF4E4E'
  }),
  tofrom: _objectSpread(_objectSpread({
    color: _styles.colors.srTextInput
  }, _styles.typography.medium), {}, {
    fontSize: 16
  }),
  date: _objectSpread(_objectSpread({
    color: _styles.colors.srTextInput
  }, _styles.typography.medium), {}, {
    fontSize: 16
  }),
  time: _objectSpread(_objectSpread({
    color: _styles.colors.srTextInput
  }, _styles.typography.medium), {}, {
    fontSize: 16
  })
});